import { ActionType } from 'typesafe-actions';
import { ModalContentProps } from '../../../layout/Master/styles';
import {
  UserAddresses,
  UserAddressShipping,
  UserCard,
  UserCardSplit,
} from '../auth/types';
import * as actions from './actions';
import { ServicesProps } from '../product/types';

export type ParameterAction = ActionType<typeof actions>;

export interface Store {
  store_id: number;
  name: string;
  corporate_name: string;
  cnpj: string;
  ie: string;
  im: string;
  address: string;
  number: string;
  neighborhood: string;
  complement: string;
  city: string;
  city_code: string;
  state: string;
  state_code: string;
  country: string;
  country_code: string;
  zip_code: string;
  phone: string;
  cellphone: string;
  email: string;
  contact_name: string;
}

export interface Locker {
  id: number;
  locker_id: string;
  name: string;
  address: string;
  number?: string;
  neighborhood: string;
  complement: string;
  city: string;
  state: string;
  state_code?: string;
  country?: string;
  country_code?: string;
  zip_code: string;
  phone?: string;
  cellphone?: string;
  email?: string;
  contact_name?: string;
}

export interface ParameterProps {
  side?: 'left' | 'right';
  isCategory?: boolean;
}

export type MethodsKeys = "cards" | "cashOnDelivery" | "others";

export interface MethodsType {
  options: Record<MethodsKeys, MethodsProps[]>;
  methodsLength: number;
}

export interface MethodsProps {
  media_id: number;
  method: string;
  name?: string;
  type?: string;
  is_card?: number;
}

export enum ParameterActionTypes {
  PARAMETER_CLEAR = '@parameter/PARAMETER_CLEAR',
  OPEN_MENU = '@parameter/OPEN_MENU',
  OPEN_MENU_BASE = '@parameter/OPEN_MENU_BASE',
  OPEN_MENU_ACCOUNT = '@parameter/OPEN_MENU_ACCOUNT',
  OPEN_MENU_ACCOUNT_CLEAR = '@parameter/OPEN_MENU_ACCOUNT_CLEAR',
  OPEN_MODAL = '@parameter/OPEN_MODAL',
  VIEW_MODAL = '@parameter/VIEW_MODAL',
  VIEW_CHECKOUT = '@parameter/VIEW_CHECKOUT',
  IS_CATEGORY = '@parameter/IS_CATEGORY',
  FIND_METHODS = '@parameter/FIND_METHODS',
  FIND_METHODS_SUCCESS = '@parameter/FIND_METHODS_SUCCESS',
  FIND_METHODS_TYPE_SUCCESS = '@parameter/FIND_METHODS_TYPE_SUCCESS',
  FIND_METHOD_ID = '@parameter/FIND_METHOD_ID',
  FIND_METHOD_ID_SUCCESS = '@parameter/FIND_METHOD_ID_SUCCESS',
  FIND_METHOD_ID_FAILURE = '@parameter/FIND_METHOD_ID_FAILURE',
  FIND_METHODS_ALL = '@parameter/FIND_METHODS_ALL',
  FIND_METHODS_ALL_SUCCESS = '@parameter/FIND_METHODS_ALL_SUCCESS',
  METHOD_FAVORITE = '@parameter/FIND_METHOD_FAVORITE',
  METHOD_FAVORITE_SUCCESS = '@parameter/FIND_METHOD_FAVORITE_SUCCESS',
  METHOD_SEL = '@parameter/METHOD_SEL',
  METHOD_SET_SELECTED = '@parameter/METHOD_SET_SELECTED',
  METHOD_CLEAR = '@parameter/METHOD_CLEAR',
  METHOD_SEL_SUCCESS = '@parameter/METHOD_SEL_SUCCESS',
  METHOD_CREATER = '@parameter/METHOD_CREATER',
  METHOD_CREATER_SUCCESS = '@parameter/METHOD_CREATER_SUCCESS',
  METHOD_REMOVE = '@parameter/METHOD_REMOVE',
  METHOD_REMOVE_SUCCESS = '@parameter/METHOD_REMOVE_SUCCESS',
  FIND_STORE_ALL = '@parameter/FIND_STORE_ALL',
  FIND_STORE_ALL_SUCCESS = '@parameter/FIND_STORE_ALL_SUCCESS',
  FIND_STORE_ALL_FAILURE = '@parameter/FIND_STORE_ALL_FAILURE',
  FIND_LOCKER_ALL = '@parameter/FIND_LOCKER_ALL',
  FIND_LOCKER_ALL_SUCCESS = '@parameter/FIND_LOCKER_ALL_SUCCESS',
  STORE_SEL = '@parameter/STORE_SEL',
  LOCKER_SEL = '@parameter/LOCKER_SEL',
  BTN_NEXT_CHECKOUT = '@parameter/BTN_NEXT_CHECKOUT',
  FIND_SHIPPING_VALUE = '@parameter/FIND_SHIPPING_VALUE',
  FIND_SHIPPING_VALUE_SUCCESS = '@parameter/FIND_SHIPPING_VALUE_SUCCESS',
  SELECT_SHIPPING_OPTION = '@parameter/SELECT_SHIPPING_OPTION',
  CLEAR_SHIPPING_OPTION = '@parameter/CLEAR_SHIPPING_OPTION',
  SET_MESSAGE_TOAST = '@parameter/SET_MESSAGE_TOAST',
  SET_MESSAGE_TOAST_CLEAR = '@parameter/SET_MESSAGE_TOAST_CLEAR',
  ADDRESSES_FIND_POSTCODE_REQUEST = '@parameter/ADDRESSES_FIND_POSTCODE_REQUEST',
  ADDRESSES_FIND_POSTCODE_SUCCESS = '@parameter/ADDRESSES_FIND_POSTCODE_SUCCESS',
  ADDRESSES_FIND_POSTCODE_FAILURE = '@parameter/ADDRESSES_FIND_POSTCODE_FAILURE',
  ADDRESSES_FIND_ALL_REQUEST = '@parameter/ADDRESSES_FIND_ALL_REQUEST',
  ADDRESSES_FIND_ALL_SUCCESS = '@parameter/ADDRESSES_FIND_ALL_SUCCESS',
  ADDRESSES_FIND_ALL_FAILURE = '@parameter/ADDRESSES_FIND_ALL_FAILURE',
  ADDRESSES_SEL = '@parameter/ADDRESSES_SEL',
  ADDRESSES_SEL_SUCCESS = '@parameter/ADDRESSES_SEL_SUCCESS',
  ADDRESSES_EDIT_REQUEST = '@parameter/ADDRESSES_EDIT_REQUEST',
  ADDRESSES_CREATED_UPDATE_REQUEST = '@parameter/ADDRESSES_CREATED_UPDATE_REQUEST',
  ADDRESSES_CREATED_UPDATE_SUCCESS = '@parameter/ADDRESSES_CREATED_UPDATE_SUCCESS',
  ADDRESSES_CREATED_UPDATE_FAILURE = '@parameter/ADDRESSES_CREATED_UPDATE_FAILURE',
  ADDRESSES_REMOVE_REQUEST = '@parameter/ADDRESSES_REMOVE_REQUEST',
  ADDRESSES_REMOVE_SUCCESS = '@parameter/ADDRESSES_REMOVE_SUCCESS',
  ADDRESSES_REMOVE_FAILURE = '@parameter/ADDRESSES_REMOVE_FAILURE',
  ORDERS_ALL_SUCCESS = '@parameter/ORDERS_ALL_SUCCESS',
  SET_SERVICE_INFO = '@parameter/SET_SERVICE_INFO',
  CLEAR_SERVICE_INFO = '@parameter/CLEAR_SERVICE_INFO',
  CLEAR_LOADING = '@parameter/CLEAR_LOADING',
  PAY_ON_DELIVERY = '@parameter/PAY_ON_DELIVERY',
  SELECT_LANGUAGE = 'SELECT_LANGUAGE',
  CALCULATE_SHIPPING_RATE_SPECIFC = '@parameter/CALCULATE_SHIPPING_RATE_SPECIFC',
  CALCULATE_SHIPPING_RATE_SPECIFC_SUCCESS = '@parameter/CALCULATE_SHIPPING_RATE_SPECIFC_SUCCESS',
  SET_MULTISTORE_SELECTED = '@parameter/SET_MULTISTORE_SELECTED',
  UPDATE_COORDINATES_REQUEST = '@parameter/UPDATE_COORDINATES_REQUEST',
  UPDATE_COORDINATES_SUCCESS = '@parameter/UPDATE_COORDINATES_SUCCESS',
}

export interface ParameterState {
  readonly isShowLeft: boolean;
  readonly isShowRight: boolean;
  readonly openMenu?: boolean;
  readonly openMenuAccuntId?: number | 0;
  readonly openModal?: boolean;
  readonly viewModal?: React.ComponentType;
  readonly viewCheckout?: boolean;
  readonly viewModalProps?: ModalContentProps;
  readonly parameter?: ParameterProps;
  readonly methodsAll?: MethodsProps[];
  readonly methodsType: MethodsType;
  readonly methods?: UserCard[];
  readonly method?: UserCard;
  readonly methodSplit?: UserCardSplit[];
  readonly isCreatedMethod: boolean;
  readonly addresses?: UserAddresses[];
  readonly address?: UserAddresses;
  readonly addressEdit?: UserAddresses;
  readonly stores?: Store[];
  readonly store?: Store;
  readonly multistoreSelected: Store;
  readonly lockers?: Locker[];
  readonly locker?: Locker;
  readonly loading?: boolean;
  readonly btnCheckoutNext?: boolean;
  readonly shippintRates?: UserAddressShipping[];
  readonly shippingOptions?: UserAddressShipping[];
  readonly selectedShippingOption?: UserAddressShipping;
  readonly versionApp?: string;
  readonly control_version?: string;
  readonly confRefrashApp?: boolean;
  readonly messageToast?: string;
  readonly typeToast?: 'success' | 'error' | 'warning';
  readonly messageTranslationId?: string;
  readonly serviceInfo?: ServicesProps;
  readonly payOnDelivery: boolean;
  readonly language?: any;
}
